/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import boxShadows from "qqq/assets/theme/base/boxShadows";
import typography from "qqq/assets/theme/base/typography";
import colors from "qqq/assets/theme/base/colors";
import borders from "qqq/assets/theme/base/borders";

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from "qqq/assets/theme/functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, white } = colors;
const { borderRadius } = borders;

// types
type Types = any;

const menu: Types = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    ////////////////////////////////////////////////////////////////////////////////////
    // mui 5.11 silently ignored this paper slot; 5.18 started honoring it, and the    //
    // 16px/8px padding it always declared suddenly inflated every menu.  no padding   //
    // here - menus render with just the popover paper's 8px, as they did before the   //
    // upgrade (the global MuiList override zeroes the list's own padding).            //
    ////////////////////////////////////////////////////////////////////////////////////
    paper: {
      minWidth: pxToRem(160),
      boxShadow: lg,
      fontSize: size.sm,
      color: text.main,
      textAlign: "left",
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.md,
    },
  },
};

export default menu;
